import AvatarWithLabel from './AvatarWithLabel';

export default AvatarWithLabel;
